import React from 'react';
import type { UserDetailsResponse } from '../../schemas/validation';
import { formatDate } from './utils';
import { getPublishedDomain } from '../../utils/publishedUrl';

interface WebsitesCardProps {
  websites: UserDetailsResponse['data']['websites'];
}

export const WebsitesCard: React.FC<WebsitesCardProps> = ({ websites }) => {
  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-6 py-4 border-b border-gray-200">
        <h3 className="text-lg font-medium text-gray-900">Websites ({websites.length})</h3>
      </div>
      <div className="px-6 py-4">
        {websites.length === 0 ? (
          <p className="text-gray-500 text-center py-4">No websites created yet</p>
        ) : (
          <div className="space-y-4">
            {websites.map(website => (
              <div key={website.id} className="border border-gray-200 rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h4 className="text-sm font-medium text-gray-900 flex items-center space-x-2">
                      <span>{website.name}</span>
                      {website.isPublished && (
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                          Published
                        </span>
                      )}
                    </h4>
                    <p className="text-sm text-gray-500">
                      {website.subdomain}.{getPublishedDomain()}
                      {website.customDomain && ` • ${website.customDomain}`}
                    </p>
                    {website.description && (
                      <p className="text-sm text-gray-600 mt-1">{website.description}</p>
                    )}
                  </div>
                  <div className="text-right text-sm text-gray-500">
                    <p>{website.statistics.totalPages} pages</p>
                    <p>Created {formatDate(website.createdAt)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
